/* Lactolerance — AJAX add-to-cart that opens Dawn's cart drawer.
   - Opens the drawer when the custom header cart icon is clicked.
   - Intercepts any form[data-lacto-ajax] submit, adds via the Cart API,
     re-renders Dawn's <cart-drawer> and opens it, and refreshes the header count.
   Falls back to a normal submit if no <cart-drawer> is present. */
(function () {
  function drawer() { return document.querySelector('cart-drawer'); }

  // Open drawer from the custom header cart icon
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.lacto-hd__cart');
    if (!link) return;
    var d = drawer();
    if (d) { e.preventDefault(); d.open(link); }
  });

  function refreshHeaderCount() {
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-lacto-ajax]');
    if (!form) return;
    var d = drawer();
    if (!d) return; // no drawer → let it submit normally to /cart

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    // Build the add payload explicitly as URL-encoded (FormData was unreliably dropping
    // the selling_plan value from the request in this flow). Read each control directly.
    var params = new URLSearchParams();
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.disabled) return;
      var t = (el.type || '').toLowerCase();
      if (t === 'submit' || t === 'button' || t === 'reset' || t === 'file' || t === 'image') return;
      if ((t === 'checkbox' || t === 'radio') && !el.checked) return;
      params.append(el.name, el.value);
    });
    // Authoritative selling_plan straight from the input (bypasses its disabled state).
    var spInput = form.querySelector('[name="selling_plan"]');
    if (spInput && spInput.value && spInput.value !== '0') {
      params.set('selling_plan', spInput.value);
    } else {
      params.delete('selling_plan');
    }
    params.set('sections', 'cart-drawer,cart-icon-bubble');
    params.set('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: params.toString(),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
        if (res.status) {
          // e.g. sold out / not available — surface the message
          alert(res.description || res.message || 'Impossible d’ajouter au panier.');
          return;
        }
        if (typeof d.renderContents === 'function') { d.renderContents(res); }
        else { d.open(); }
        refreshHeaderCount();
        document.dispatchEvent(new CustomEvent('lacto:cart-updated'));
      })
      .catch(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
        form.submit();
      });
  });
})();
